<div class="d-flex flex-column justify-content-center">
	<button class="mx-auto pay-button pay-hidden google-pay-button my-2"></button>
	<button class="mx-auto pay-button pay-hidden apple-pay-button my-2"></button>
</div>

<div id="i4goFrame" class="mb-3" [hidden]="!i4goAccessBlock">
	<div style="height: 250px; position: relative">
		<div class="p-5 w-100 text-center">Loading Secure Payment</div>
		<ngx-loading
			[show]="true"
			[config]="{
				primaryColour: 'rgb(255,114,0,0.75)',
				secondaryColour: 'rgb(255,114,0,0.75)',
				tertiaryColour: 'rgb(255,114,0,0.75)',
				backdropBackgroundColour: 'rgb(255,255,255,0)'
			}"
		>
		</ngx-loading>
	</div>
</div>
